import React       from 'react';
import ReactDom    from 'react-dom';

import Utils       from 'utils';

import DraftFlow   from '@draft/draft-flow';
// -------------------------------------------------------

class InputTextarea extends React.Component {
  update(value, mode, flow_no, option) {
    let update = this.props.update;
    
    console.log([value, mode, flow_no, option]);
    //this.props.update_ev.bind(this)(this.item.value);
    
    let draft_flow = [];
    try { if( update.draft_flow_template != null ) draft_flow = JSON.parse(update.draft_flow_template); } catch(e) {}
    
    if( mode == 'delete' ){
      draft_flow = draft_flow.filter((d) => { if( d.order_no != flow_no ) return d; });
    } else {
      if( option != undefined && option.change_type == 'update' ){
        
        // データアップデート
        draft_flow = draft_flow.map((d) => {
          if( d.id == option.change_id ){
            if( mode == 'my_members' ){
              d.user_id = value;
              d.guest_company_id = null;
            } else {
              d.user_id = null;
              d.guest_company_id = value;
            }
          }
          return d;
        });
        
      } else {
        
        draft_flow = draft_flow.map((d, key) => {
          if( flow_no < (key + 1) ) d.order_no += 1;
          return d;
        });
        
        // データ登録
        if( mode == 'guest_companys' ){
          draft_flow.push({ id: Utils.getUniqueID(), guest_company_id: value, user_id: null, order_no: flow_no });
        } else {
          draft_flow.push({ id: Utils.getUniqueID(), user_id: value, guest_company_id: null, order_no: flow_no });
        }
        
      }
    }
    
    draft_flow = Utils.sort(draft_flow, 'order_no', 'asc');
    draft_flow = draft_flow.map((d, key) => {
      d.order_no = (key + 1);
      return d;
    });
    
    this.props.update_ev.bind(this)(JSON.stringify(draft_flow));
    console.log(draft_flow);
    
  }
  
  render() {
    let data = this.props.data;
    let update = this.props.update;
    let management = this.props.base.management;
    
    // 会社アカウント
    let my_members = [];
    management.users.map((d) => { if( d.is_guest == 0 ) my_members.push(d); });
    
    // ゲストアカウント
    let guest_members = [];
    try {
      guest_members = management.users.filter((d) => { if( update.management_guest.split(',').indexOf(String(d.id)) >= 0 ) return d; });
    } catch(e) {}
    
    // ゲスト会社
    let guest_companys = [];
    try {
      guest_companys = management.guest_companys.filter((d) => { if( update.management_company.split(',').indexOf(String(d.id)) >= 0 ) return d; });
    } catch(e) {}
    
    let members = {
      my_members     : my_members,
      guest_members  : guest_members,
      guest_companys : guest_companys,
    }
    
    // 下書きフロー
    let draft_flow = [];
    try { if( update.draft_flow_template != null ) draft_flow = JSON.parse(update.draft_flow_template); } catch(e) {}
    
    draft_flow = draft_flow.map((d) => {
      if( d.user_id != null ){
        management.users.map((u) => { if( u.id == d.user_id ) d.user = u; });
      }
      if( d.guest_company_id != null ){
        management.guest_companys.map((u) => { if( u.id == d.guest_company_id ) d.guest_company = u; });
      }
      return d;
    });
    
    return (
      <div className="textarea">
        <DraftFlow draft_flow={draft_flow} flow_no={0} members={members} set_ev={this.update.bind(this)} is_edit={true} />
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default InputTextarea;